import pxToRem from "../utils/pxToRem"

export const dimensions = {
  nav: {
    logo: {
      md: {
        width: pxToRem(164),
        height: pxToRem(150)
      },
      sm: {
        width: pxToRem(110),
        height: pxToRem(99)
      }
    },
    hamburguer: {
      height: pxToRem(30)
    },
    menuHeight: {
      sm: pxToRem(56),
      md: pxToRem(90)
    },
    languageToggleSquare: pxToRem(36),
    searchToggle: {
      width: pxToRem(22),
      height: pxToRem(66),
      buttonPadding: pxToRem(22),
      searchBoxPadding: `${pxToRem(8)} ${pxToRem(9)} ${pxToRem(10)} ${pxToRem(10)}`
    }
  },
}
